export const publishWebConstants = {
    PUBLISH_WEB_PENDING:   'PUBLISH_WEB_PENDING',
    PUBLISH_WEB_FULFILLED:   'PUBLISH_WEB_FULFILLED',
    PUBLISH_WEB_REJECTED:   'PUBLISH_WEB_REJECTED',
};
